import { render, staticRenderFns } from "./ConfirmSyncInvoice.yaml?vue&type=template&id=60763afc&component"
import script from "./ConfirmSyncInvoice.yaml?vue&type=script&lang=ts&component"
export * from "./ConfirmSyncInvoice.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports